import { createContext, useContext } from 'react';

/**
 * Navigation concerns the ProjectPage needs in order to work.
 *
 * The routed app implements this via react-router (see RouterProjectNavigationProvider),
 * while the standalone (routerless) entry point implements it from init arguments
 * (see StandaloneProjectNavigationProvider). This lets ProjectPage stay agnostic of
 * whether it is mounted inside a router or as a self-contained widget.
 */
export type ProjectNavigation = {
    /** Currently displayed pagination page (1-based). */
    currentPage: number;
    /** Navigate to another pagination page. */
    goToPage: (page: number) => void;
    /** Leave the projects view (the "close/back" action). */
    goBack: () => void;
    /** Navigate to the home page (the "add new selection" action). */
    goHome: () => void;
    onNavigate: (url: string) => void;
};

export const ProjectNavigationContext = createContext<ProjectNavigation | null>(null);

export const useProjectNavigation = (): ProjectNavigation => {
    const navigation = useContext(ProjectNavigationContext);
    if (navigation === null) {
        throw new Error('useProjectNavigation must be used within a ProjectNavigationContext provider');
    }
    return navigation;
};
